const COLORS = [
    '#4dc9f6',
    '#f67019',
    '#7C8B27',//'#acc236',
    //'#f53794',
    '#537bc4',
    '#166a8f',
    '#00a950',
    '#58595b',
    '#8549ba'
  ];

export var ChartColors = {
    Colors: COLORS,
    getColor: (i) => {
        return COLORS[i % COLORS.length];
    }
}